











































import {Component, Vue} from 'vue-property-decorator';
import MachineWorkingDiagram from '@c/services/monitorErrors/MachineWorkingDiagram.vue';
import ServiceSettingsSelectBox from '@c/ServiceSettingsSelectBox.vue';
import {getDurationStr} from '@u/dateTimeUtils';
import {DateTimeInterval} from '@u/dateTimeItervalUtils';
import DiagramLegendTable from '@c/diagrams/DiagramLegendTable.vue';
import {requestWorkloadData, exportReport} from '@api/services/workloadApi';
import {
  statusDiagramColorScheme as colorScheme,
  machineWorkingStatusTitles as titleScheme,
} from '@c/system/configurate';
import {SystemNode} from '@c/system/interfaces';
import {getArrayData} from '@u/machineWorkingUtils';
import Loading from '@c/controls/Loading.vue';
import {Can} from '@casl/vue';

@Component({
  components: {
    MachineWorkingDiagram,
    ServiceSettingsSelectBox,
    DiagramLegendTable,
    Loading,
    Can,
  },
})
export default class WorkloadView extends Vue {
  //показатели загрузки данных и наличия ошибок получения данных с сервера
  workloadLoading = false;
  workloadError = false;

  states: any[] = [];

  //Ключ компоненты диаграммы
  diagramKey = 0;

  //данные для легенды
  legendInfo = [
    {color: colorScheme.off, name: titleScheme.off},
    {color: colorScheme.idle, name: titleScheme.idle},
    {color: colorScheme.work, name: titleScheme.work},
    {color: colorScheme.incorrect, name: titleScheme.incorrect},
  ];

  // Точность представления процентов в легенде
  viewRoundingAccuracy = 2;

  legendData: any[] = [];

  // Заголовки столбцов таблицы легенды
  labelsLegendTable = [
    {name: 'Статус', field: 'name'},
    {name: 'Время', field: 'value'},
    {name: '%', field: 'percent'},
  ];

  //цвета для фона
  colorsBgInterval = [colorScheme.off, colorScheme.idle, colorScheme.work, colorScheme.incorrect];

  // Показывать кнопку сохранения отчета или нет
  isShowSaveReportButton = false;

  machineId!: string;

  startDate!: number;

  endDate!: number;

  async getDataWithTimeFromComponent(serviceSettings: {
    machine: SystemNode;
    dateInterval: DateTimeInterval;
  }) {
    await this.getData(serviceSettings.machine, serviceSettings.dateInterval);
  }

  // вычисление процента
  countPercent(aggregateTimeinMillsSec: number, startDate: number, endDate: number) {
    if (!aggregateTimeinMillsSec || endDate === startDate)
      return (0).toFixed(this.viewRoundingAccuracy);
    return ((aggregateTimeinMillsSec / (endDate - startDate)) * 100).toFixed(
      this.viewRoundingAccuracy,
    );
  }

  // Получение данных для легенды
  getLegendData(intervalsModes: any[], startDate: number, endDate: number) {
    const aggregateTime = intervalsModes.reduce((res: any[], x: any) => {
      res[x.mode] = res[x.mode] + (x.end - x.start) || x.end - x.start;
      return res;
    }, {});

    return this.legendInfo.map((elem: any, index: number) => ({
      ...elem,
      value: getDurationStr(aggregateTime[index]),
      percent: this.countPercent(aggregateTime[index], startDate, endDate),
    }));
  }

  async getData(machine: SystemNode, dateInterval: DateTimeInterval) {
    this.startDate = dateInterval.startDateTime as number;
    this.endDate = dateInterval.endDateTime as number;
    this.machineId = machine.id;
    this.workloadLoading = true;
    this.workloadError = false;
    requestWorkloadData(machine.id, this.startDate, this.endDate)
      .then((res: any) => {
        const {intervalsModes} = res;

        this.states = getArrayData(
          intervalsModes,
          this.colorsBgInterval,
          10,
          (elem: any) => elem.mode,
        );

        this.legendData = this.getLegendData(intervalsModes, this.startDate, this.endDate);
        //Обновляем график и перерисовываем компоненту, чтобы сбросить область видимости
        (this.$refs.machineWorkingDiagram as any).onChartMounted();
        this.diagramKey++;

        //Показываем кнопку выгрузки отчета в гугл
        this.isShowSaveReportButton = true;
      })
      .catch(() => {
        this.workloadError = true;
      })
      .finally(() => {
        this.workloadLoading = false;
      });
  }

  uploadReportInGoogle(params: {reportFileName: string; keyFilename: string}) {
    this.workloadLoading = true;
    this.workloadError = false;
    const {reportFileName, keyFilename} = params;
    exportReport(this.machineId, this.startDate, this.endDate, reportFileName, keyFilename)
      .then((res: any) => {
        window.open(res.data, '_blank');
      })
      .catch(() => {
        this.workloadError = true;
      })
      .finally(() => {
        this.workloadLoading = false;
      });
  }
}
